import { MerchFlowCoreRange } from "../../../merchandise";
import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";
import { CdtRuleSet } from "../cdt/compression";
import type { BaseLoaderEvidencePayload, FixtureDividerRow } from "@CommonUtils/pog/dividerPolicy";

export const RouteGetMerchflows_merchflowId_BasePog_basePogId_ =
  "/merchflows/:merchflowId/base-pog/:basePogId";

export type BasePogFlowType = "UHD";
export type GenerationCdtSource = "BASE_POG" | "STORE_PRODUCT";

export interface BasePogFlowReviewConfig {
  option?: MerchFlowCoreRange;
  flowType?: BasePogFlowType;
  generationCdtSource?: GenerationCdtSource;
}

export interface ResponseGetMerchflows_merchflowId_BasePog_basePogId_ {
  id: number;
  template_id: string | null;
  pog: PogNonCircular | null;
  favorited: boolean;
  merchflow_id: number;
  filter_config_id: number;
  s2_solution_id: number | null;
  store_id: number | null;
  store_code: string | null;
  status: "IN_PROGRESS" | "ERROR" | "DONE";
  error_logs: object;
  generationCdtSource: GenerationCdtSource;
  /**
   * The newest CDT Studio release for this base planogram, or null when the
   * studio was never finalized for it. The same id a store generation started
   * now would pin, so the screen can say which CDT a run will use before it runs.
   */
  cdtReleaseId: number | null;
  /**
   * How that release blocks the wall, a rule set's absent value already read as "vertical";
   * null with no release. Absent from older backends.
   */
  cdtReleaseWallBlocking?: NonNullable<CdtRuleSet["wallBlocking"]> | null;
  flow_review: {
    config: BasePogFlowReviewConfig | null;
  } | null;
  /** Only GET /merchflow/base-pog/:basePogId fills it; null without a pog. */
  loaders?: BaseLoaderEvidencePayload | null;
  /**
   * The base store's fixture rows with their divider columns, for the rules modal's
   * "kept from the store fixture" rows (`keptFixtureDividerShelves`). Only GET
   * /merchflow/base-pog/:basePogId fills it; null without a pog, without a known base
   * store or when the rows cannot be read (the modal then reads the base pog's shelves).
   */
  fixtureDividerRows?: FixtureDividerRow[] | null;
}
